import { isEmptyObject } from "../Utility";
// add persing for future
class moduleParser {
  static moduleAccess(data) {
    const { website_modules } = data || {};
    if (!website_modules) return;
    if (isEmptyObject(website_modules)) return;
    const modules = {
      ...website_modules,
      canAccessPackages:website_modules?.packages_api || website_modules?.packages || false,
      packagesV2: website_modules?.packages_api || false,
    };

    return modules;
  }
}

export default moduleParser;
